module.exports = __webpack_public_path__ + "static/media/ETMALC1.8ed471ef.png";